
export abstract class NewplaPageUtils {

    public static browserInitError: (err: any) => void = (err) => {
        console.log(err);
        alert('페이지 초기화를 실패했습니다.');
    };

    public static wait(timeToDelay: number) {
        return new Promise((resolve) => setTimeout(resolve, timeToDelay));
    }

}